
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzEmptyModule, NzPopoverModule } from 'ng-zorro-antd';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzCascaderModule } from 'ng-zorro-antd/cascader';
import { IconDefinition } from '@ant-design/icons-angular';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import * as AllIcons from '@ant-design/icons-angular/icons';

const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(key => antDesignIcons[key]);

export const SHARED_ZORRO_MODULES = [
  NzButtonModule,
  NzIconModule.forRoot(icons),
  NzIconModule,
  NzInputModule,
  NzFormModule,
  NzMessageModule,
  NzLayoutModule,
  NzMenuModule,
  NzSpinModule,
  NzDropDownModule,
  NzBreadCrumbModule,
  NzTableModule,
  NzCheckboxModule,
  NzTreeModule,
  NzGridModule,
  NzModalModule,
  NzSpaceModule,
  NzSelectModule,
  NzTimePickerModule,
  NzUploadModule,
  NzDatePickerModule,
  NzPaginationModule,
  NzTabsModule,
  NzRadioModule,
  NzEmptyModule,
  NzInputNumberModule,
  NzDividerModule,
  NzResultModule,
  NzStepsModule,
  NzAlertModule,
  NzTagModule,
  NzToolTipModule,
  NzCascaderModule,
  NzPopoverModule,
  NzCollapseModule
];
